import { type SvgProps, SvgWrapper } from '../utils';

export function ExclaimIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M11 13L11 6C11 5.44772 11.4477 5 12 5C12.5523 5 13 5.44771 13 6L13 13C13 13.5523 12.5523 14 12 14C11.4478 14 11 13.5523 11 13Z" />
      <path d="M12.0098 16.25C12.7001 16.25 13.2598 16.8096 13.2598 17.5C13.2598 18.1904 12.7001 18.75 12.0098 18.75H12C11.3096 18.75 10.75 18.1904 10.75 17.5C10.75 16.8096 11.3096 16.25 12 16.25H12.0098Z" />
    </SvgWrapper>
  );
}
